import { useContext } from 'react';
import { Filters } from 'consts/transactions';
import { useParams } from 'infrastructure/router';
import type { ID } from 'types';
import {
    KYCMerchantIdContext,
    KYCSettingsActionsContext,
    KYCSettingsStateSelectorsContext
} from './KYCSettingsProvider';

export const useKYCSettingsStateSelectorsContext = () =>
    useContext(KYCSettingsStateSelectorsContext);

export const useKYCSettingsActionsContext = () =>
    useContext(KYCSettingsActionsContext);

export const useKYCMerchantId = (): ID | undefined => {
    const contextValue = useContext(KYCMerchantIdContext);
    const params = useParams();
    return contextValue ?? params[Filters.merchantId];
};
